<template>
	<div>
		<a-modal v-show='!ishand' id='supplylists' width='40rem' v-model="visible" on-ok="handleOk1" v-dragModal
			@cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
			<div class='mark-file'>
				<div
					style="background-color: #0c8b97;border-radius:  10px 10px 0 0;color: #fff;width: 38rem;margin: 1rem 1rem 0 1rem;text-align: center;">
					查看詳情
				</div>
			</div>
			<div solt='title' style="position: relative;">
				<!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
			</div>
			<div style="paddingBottom: 1rem;border-radius: 0 0 10px 10px;padding: 1rem;background-color: #fff;
			width: 38rem;margin: 0 auto;marginBottom: 1rem;">
				<div style="padding-top: 1.5rem;position: relative;max-height: 37rem;overflow-y: auto;">
					<div class="yhxx_class">
						<div></div>
						銀行信息
					</div>
					<a-form-model ref='form' :model="form" labelAlign='left' layout="inline" :rules='rules'
						id='myformore' hideRequiredMark>
						<a-row>
							<a-col :span='6'>受款帳戶名稱:</a-col>
							<a-col :span='18'>{{form.accountname_cn}}<img src="@/image/heardright/copy.png"
									@click="fzEvent(form.accountname_cn)" class='iscopy_img'
									:style='{opacity:form.accountname_cn?1:0}' /> </a-col>
							<a-col :span='6'>Account Name:</a-col>
							<a-col :span='18'>{{form.accountname_en}}<img src="@/image/heardright/copy.png"
									@click="fzEvent(form.accountname_en)" class='iscopy_img' /></a-col>
						</a-row>
						<br>
						<a-row>
							<a-col :span='6'>收款銀行名稱:</a-col>
							<a-col :span='18'>{{form.bankname_cn}}<img src="@/image/heardright/copy.png"
									@click="fzEvent(form.bankname_cn)" class='iscopy_img' /></a-col>
							<a-col :span='6'>Bank Name:</a-col>
							<a-col :span='18'>{{form.bankname_en}}<img src="@/image/heardright/copy.png"
									@click="fzEvent(form.bankname_en)" class='iscopy_img' /></a-col>
						</a-row>
						<br>
						<a-row>
							<a-col :span='6'>
								<a-row v-for='(v,a) in form.accountnumberList' :key='a'>
									<a-col :span='24'>
										<div v-if='!a'>戶口號碼:</div>
									</a-col>
									<a-col :span='24'>
										<div v-if='!a'>Account Number:</div>
									</a-col>
								</a-row>
							</a-col>
							<a-col :span='18'>
								<a-row v-for='(v,a) in form.accountnumberList' :key='a'>
									<a-col :span='24'>{{v.account_number+'('
									+v.ccytype+')'}}<img src="@/image/heardright/copy.png" @click="fzEvent(v.account_number+'('
									+v.ccytype+')')" class='iscopy_img' /></a-col>
								</a-row>
							</a-col>
						</a-row>
						<br>
						<a-row>
							<a-col :span='6'>匯款銀行代碼:</a-col>
							<a-col :span='18'>{{form.swift_code}}<img src="@/image/heardright/copy.png"
									@click="fzEvent(form.swift_code)" class='iscopy_img' /></a-col>
							<a-col :span='6'>SWIFT Code:</a-col>
							<a-col :span='18'></a-col>
						</a-row>
						<br>

						<!-- <a-row>
							<a-col :span='6'>戶口號碼:</a-col>
							<a-col :span='18'>{{form.accountnumberList[0].account_number+'('
							+form.accountnumberList[0].ccytype+')'}}<img src="@/image/heardright/copy.png" @click="fzEvent(form.accountnumberList[0].account_number+'('
							+form.accountnumberList[0].ccytype+')')" class='iscopy_img' /></a-col>
							<a-col :span='6'>Account Number:</a-col>
							<a-col :span='18' v-if='form.accountnumberList.length==2'>
								{{form.accountnumberList[1].account_number+'('
							+form.accountnumberList[1].ccytype+')'}}<img src="@/image/heardright/copy.png" @click="fzEvent(form.accountnumberList[1].account_number+'('
							+form.accountnumberList[1].ccytype+')')" class='iscopy_img' />
							</a-col>
						</a-row> -->
						<a-row>
							<a-col :span='6'>銀行地址:</a-col>
							<a-col :span='18'>{{form.address_cn}}<img src="@/image/heardright/copy.png"
									@click="fzEvent(form.address_cn)" class='iscopy_img' /></a-col>
							<a-col :span='6'>Bank Address:</a-col>
							<a-col :span='18'>{{form.address_en}}<img src="@/image/heardright/copy.png"
									@click="fzEvent(form.address_en)" class='iscopy_img' /></a-col>
						</a-row>
						<div class="yhxx_class" style="margin-top: 1rem;">
							<div></div>
							銀行聯絡人
							<span >
								<img style="margin-bottom: 5px;width: 20px;margin-left: 10px;" src="../../../image/xg2.png" alt="" v-if="khFlag" @click=" khFlag = !khFlag">
								<img style="margin-bottom: 5px;width: 20px;margin-left: 10px;" src="../../../image/xg1.png" alt="" v-if="!khFlag"  @click=" khFlag = !khFlag">
							</span>
						</div>
						<div class="flex_div" style="margin-bottom: 0.5rem;">
							<div class="flex_div">
								<div class="flex_div">
									<div class="flex_div_lable">聯絡名稱:</div>
										<a-form-model-item prop='contact_person' style="width: 100%;">
											<a-input :disabled="!khFlag" v-model="form.contact_person" class='warp_width' @input='getdata' placeholder='請輸入聯絡名稱'/>
										</a-form-model-item>
									</div>
							</div>
							<div class="flex_div_width"></div>
							<div class="flex_div">
								<div class="flex_div">
									<div class="flex_div_lable">電話號碼:</div>
										<a-form-model-item label='' prop='contact_person_phone' style="width: 100%;">
											<a-input :disabled="!khFlag" v-model="form.contact_person_phone" class='warp_width' placeholder='請輸入電話號碼'
											@input="form.contact_person_phone = form.contact_person_phone.replace(/[^0-9 %&',;=?$x22]/g,'')"/>
										</a-form-model-item>
									</div>
							</div>
						</div>
						<div class="flex_div" style="margin-bottom: 0.5rem;">
							<div class="flex_div">
								<div class="flex_div">
									<div class="flex_div_lable">電子郵箱:</div>
										<a-form-model-item  prop='contact_person_email' style="width: 100%;">
											<a-input :disabled="!khFlag" @blur='emailfn()' v-model="form.contact_person_email" class='warp_width' @input='getdata' placeholder='請輸入電子郵箱'/>
										</a-form-model-item>
									</div>
							</div>
							<div class="flex_div_width"></div>
							<div class="flex_div">
							</div>
						</div>
						<div class="flex_div" style="margin-bottom: 0.5rem;">
							<div class="flex_div">
								<div class="flex_div">
									<div class="flex_div_lable">備註:</div>
									<a-form-model-item  style="width: 100%;">
										<a-input :disabled="!khFlag" v-model="form.remark" class='warp_width'  placeholder='請輸入備註'/>
									</a-form-model-item>
								</div>
							</div>
						</div>
					</a-form-model>
					<div style="text-align: center;padding: 1rem 0;">
						<button class='btn1 btnx' @click='handbect("form")' v-html='"保&emsp;存"'></button>
					</div>
				</div>
			</div>
			<div style="width: 100%;height: 1px;"></div>
		</a-modal>
	</div>
</template>

<script>
	import App from '@/assets/app.js';
	export default {
		props: ['items'],
		data() {
			return {
				khFlag:false,
				ishand: false,
				fourthqty: '',
				labelCol: {
					span: 10
				},
				wrapperCol: {
					span: 14
				},
				visible: true,
				rules: {
					// mobileservice: [{
					// 	required: true,
					// 	message: ' ',
					// 	trigger: 'blur'
					// }],
					// register_date: [{
					// 	required: true,
					// 	message: ' ',
					// 	trigger: 'change'
					// }],
					// expire_date: [{
					// 	required: true,
					// 	message: ' ',
					// 	trigger: 'change'
					// }],
					// domainname_type: [{
					// 	required: true,
					// 	message: ' ',
					// 	trigger: 'change'
					// }],
					// supplier: [{
					// 	required: true,
					// 	message: ' ',
					// 	trigger: 'blur'
					// }],
					contact_person:[{required:true,message:' ',trigger:'blur'}],
					contact_person_phone:[{required:true,message:' ',trigger:'blur'}],
					contact_person_email:[{required:true,message:' ',trigger:'blur'}],
					// remark:[{required:true,message:' ',trigger:'blur'}],
				},
				form: {
					"bankname_cn": "",
					"bankname_en": "",
					"accountname_cn": "",
					"accountname_en": "",
					"address_cn": "",
					"address_en": "",
					"swift_code": "",
					"contact_person":"",
					"contact_person_phone":"",
					"contact_person_email":"",
					"remark":"",
					"is_edit":"",
					"token": "",
					"accountnumberList": [{
						"account_number": "",
						"ccytype": ""
					}]
				},
			}
		},
		watch: {
			items: {
				deep: true,
				handler(ev) {}
			},
		},
		mounted() {
			this.handz()
			console.log(this.items);

		},
		methods: {
			emailfn() {
				if (this.form.contact_person_email) {
					var t = /^[A-Za-zd0-9]+([-_.][A-Za-zd]+)*@([A-Za-zd]+[-.])+[A-Za-zd]{2,5}$/;
					if (!(t.test(this.form.contact_person_email))) {
						this.form.contact_person_email = ''
						this.$message.warning('請輸入正確的電郵地址')
					}
				}
			},
			fzEvent(value) {
				if (value) {
					let clipboard = new this.$clipboard('img', {
						text: function() {
							return value
						}
					})
					clipboard.on('success', e => {
						App.oTool.successT('複製成功');
						clipboard.destroy(e)
					})
					clipboard.on('error', e => {
						App.oTool.warningT('複製失敗');
						clipboard.destroy(e)
					})
				}
			},
			disabledDate(current) {
				if (this.form.expire_date) {
					return current && current > new Date(this.form.expire_date)
				} else {
					return false
				}
			},
			disabledDates(current) {
				if (this.form.register_date) {
					return current && current < new Date(this.form.register_date)
				} else {
					return false
				}
			},
			getdata() {

			},
			//获取美国 香港当地时间
			handz(val) {
				this.$ajax({
					method: 'post',
					url: this.$api.getQmisBankInfo,
					data: {
						"bankid": this.items
					}
				}).then(res => {
					if (res.data) {
						this.form = res.data
						// App.oTool.successT();
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
				// this.handz()
			},
			//下单
			handbect(ruleForm) {
				this.$refs[ruleForm].validate(valid => {
					if (valid) {
						this.$ajax({
							method: 'post',
							url: this.$api.updateBankContactPerson,
							data: this.form
						}).then(res => {
							if (res.data.qmiscode === 1000) {
								App.oTool.successT();
								this.$emit('child', 1)
							} else {
								App.oTool.warningT(res.data.qmismsg);
							}
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
				return
				this.$refs[ruleForm].validate(valid => {
					if (valid) {
						this.form.register_date = this.form.register_date._d ? App.oDate.secsTime3(this.form
							.register_date._d) : this.form.register_date;
						this.form.expire_date = this.form.expire_date._d ? App.oDate.secsTime3(this.form
							.expire_date._d) : this.form.expire_date;
						this.form.token = this.$store.state.token;
						this.form.flag = "mobileservice";
						this.$ajax({
							method: 'post',
							url: this.$api.newOther,
							data: this.form
						}).then(res => {
							if (res.data.qmiscode === 1000) {
								App.oTool.successT();
								this.$emit('child', 1)
							} else {
								App.oTool.warningT(res.data.qmismsg);
							}
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			handleCancel(ev) {
				this.$emit('child', 0)
			},
			handleOk1() {

			}
		}
	}
</script>

<style>
	.ant-form-explain{
		display: none;
	}
	#myformore .ant-col-6 {
		color: #000000;
		font-size: .8rem;
	}

	#myformore .ant-col-18 {
		color: #000000;
		font-size: .8rem;
	}
</style>

<style lang="scss">
	.flex_div{
		display:flex;
		align-items: center;
		width: 100%;
	}
	.flex_div_lable{
		width: 4.5rem;
		flex-shrink: 0;
		font-size: 0.8rem !important;
		color: #000000;
	}
	.flex_div .ant-col{
		width: 100%;
	}
	.flex_div_width{
		display:flex;
		align-items: center;
		width: 5%;
		flex-shrink: 0
	}
	.warp_width{
		width: 100%;
	}
	.yhxx_class{
		font-size: 0.9rem;
		font-weight: 600;
		display: flex;
		align-items: center;
		margin-bottom: 1rem;
	}
	.yhxx_class div{
		width: 3px;
		height: 18px;
		background-color: #0c8b97;
		margin-right: 8px;
	}
	.iscopy_img {
		height: 0.9rem;
		width: 0.9rem;
		display: inline-block;
		position: relative;
		top: -.1rem;
		left: 1rem;
	}

	#supplylists .warp-word {
		display: inline-block;
		width: 16rem !important;
		color: #000;
		width: 100%;
	}

	#supplylists .warp-words {
		display: inline-block;
		width: 14rem !important;
		color: #000;
		width: 100%;
	}

	#supplylists .ant-modal-header,
	#supplylists .ant-modal-body {
		background-color: #e5e5e5 !important;
		padding: 1rem;
		padding-top: 0.7rem;
	}

	.mark-file {
		position: absolute;
		top: 0;
		left: 0;

		div {
			width: 6rem;
			font-size: 1rem;
			padding: .5rem 1rem;
			display: inline-block;
		}
	}

	.mark-file1 {
		position: absolute;
		top: 0;
		left: 0;
		width: 19rem;

		div {
			font-size: 1rem;
			padding: .5rem 1rem;
			background-color: #0c8b97;
			border-radius: 10px 10px 0 0;
			color: #fff;
			text-align: center;
		}
	}

	#supplylists {
		.ant-modal {
			top: 5vh;
		}

		.ant-form-inline .ant-form-item {
			margin-right: 0;
		}

		.ant-modal-content {
			border-radius: 10px;
		}

		.ant-form-item {
			margin-bottom: .2rem;
		}

		.ant-form-item label {
			font-size: .8rem !important;
		}

		.ant-form-item-children {
			font-size: .8rem !important;
			color: #000000;
		}

		.mydivs {
			max-height: 11rem;
			overflow-y: auto;
			// margin-bottom: 1rem;
			padding: 1rem;
			margin-left: 4%;
			width: 96%;
			background-color: #f5f5f5;
			margin-bottom: 1rem;

			.c {
				font-size: .8rem;
			}

			.f {
				display: flex;
				justify-content: space-between;
			}

			.t {
				margin: .5rem 0;
				border-bottom: 1px solid #d9d9d9;
			}
		}

		.ant-modal-body {
			padding: 0;
			padding-top: 2.5rem;
		}

		.btn1 {
			cursor: pointer;
			width: 8rem;
			height: 2rem;
			font-size: .8rem;
			color: #fff;
			border: 0;
			border-radius: 5px;
			margin: 0 3rem;
		}

		.btnx {
			background-color: #0c8b97;
		}

		.btn2 {
			background-color: #999999;
		}
	}
</style>
